import React from 'react'
import WinnerStatusComponent from '../../../Components/AdminComponent/WinnerStatusComponent/WinnerStatusComponent'
import AdminHeader from '../../../Components/AdminComponent/AdminHeader/AdminHeader'
import AdminSidebar from '../../../Components/AdminComponent/AdminSidebar/AdminSidebar'

const WinnerStatus = () => {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
    <AdminHeader />
    <div className='row col-lg-12'>
        <AdminSidebar />
        <div className='col-lg-10 right_content'>
            <WinnerStatusComponent 
            />

        </div>
    </div>
</div>
  )
}

export default WinnerStatus
